// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"7e9490e3","411":"1f344842"}[chunkId] + ".chunk.js";
};